import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import {
  FiArrowRight,
  FiArrowUpRight,
  FiPlay,
  FiCheckCircle,
  FiActivity,
  FiCpu,
  FiZap,
  FiTrendingUp,
  FiMoreHorizontal,
  FiClock,
  FiMessageSquare,
  FiDatabase,
  FiBarChart2,
  FiLink2,

} from "react-icons/fi";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import logo from "../../assets/dropgear-favicon.png";


import "../Home.css";



const Home = () => {

  const [activeFaqTab, setActiveFaqTab] = useState("capabilities");
  const [openFaq, setOpenFaq] = useState("cap-1");

  return (
    <>
      <Header />

      <main className="home-page">

        {/* =====================================================
            HERO SECTION
        ====================================================== */}
        <section className="home-hero">

          {/* Background elements */}
          <div className="hero-grid-bg"></div>

          <div className="hero-glow hero-glow-one"></div>
          <div className="hero-glow hero-glow-two"></div>

          <div className="home-container">

            <div className="hero-layout">

              {/* =================================================
                  LEFT CONTENT
              ================================================== */}
              <div className="hero-content">

                <div className="hero-badge">
                  <span className="hero-badge-dot"></span>

                  AI-powered SaaS for modern businesses
                </div>


                <h1 className="hero-title">
                  Intelligence that
                  <br />

              <span>moves business</span>
                  <br />

                  forward.
                </h1>


                <p className="hero-description">
                  Dropgear IO builds AI-powered SaaS platforms,
                  intelligent automation systems, and AI agents
                  that help businesses simplify operations,
                  make smarter decisions, and scale with confidence.
                </p>


                {/* HERO ACTIONS */}
                <div className="hero-actions">

                  <a
                    href="/book-demo"
                    className="hero-primary-button"
                  >
                    Book a Demo
                    <FiArrowRight />
                  </a>

                  <a
                    href="/how-it-works"
                    className="hero-secondary-button"
                  >
                    <span className="hero-play-icon">
                      <FiPlay />
                    </span>

                    See How It Works
                  </a>

                </div>


                {/* TRUST POINTS */}
                <div className="hero-trust">

                  <div className="hero-trust-item">
                    <FiCheckCircle />
                    AI-native
                  </div>

                  <div className="hero-trust-item">
                    <FiCheckCircle />
                    Automation ready
                  </div>

                  <div className="hero-trust-item">
                    <FiCheckCircle />
                    Built to scale
                  </div>

                </div>



              </div>


              {/* =================================================
                  RIGHT DASHBOARD
              ================================================== */}
              <div className="hero-dashboard-wrapper">

                {/* Floating top badge */}
                <div className="dashboard-floating-badge dashboard-badge-top">

                  <span className="dashboard-live-dot"></span>

                  AI System Online

                </div>


                {/* MAIN DASHBOARD */}
                <div className="hero-dashboard">

                  {/* =============================================
                      DASHBOARD HEADER
                  ============================================== */}
                  <div className="dashboard-header">

                    <div className="dashboard-brand">

                      <div className="dashboard-logo">
                        <img src={logo} alt="dropgear" style={{ width: "30px", height: "30px" }} />
                      </div>

                      <div>
                        <strong>
                          Dropgear IO Command
                        </strong>

                        <span>
                          AI Operations
                        </span>
                      </div>

                    </div>


                    <div className="dashboard-header-right">

                      <div className="dashboard-status">
                        <span></span>
                        Live
                      </div>

                      <FiMoreHorizontal />

                    </div>

                  </div>


                  {/* =============================================
                      DASHBOARD BODY
                  ============================================== */}
                  <div className="dashboard-body">

                    {/* SIDEBAR */}
                    <aside className="dashboard-sidebar">

                      <div className="sidebar-item sidebar-item-active">
                        <FiBarChart2 />
                        <span>Overview</span>
                      </div>

                      <div className="sidebar-item">
                        <FiCpu />
                        <span>AI Agents</span>
                      </div>

                      <div className="sidebar-item">
                        <FiZap />
                        <span>Automations</span>
                      </div>

                      <div className="sidebar-item">
                        <FiDatabase />
                        <span>Data</span>
                      </div>

                    </aside>


                    {/* CONTENT */}
                    <div className="dashboard-content">

                      {/* TOP ROW */}
                      <div className="dashboard-welcome">

                        <div>
                          <span>
                            AI OPERATIONS
                          </span>

                          <h3>
                            Good evening, Shyam
                          </h3>
                        </div>

                        <div className="dashboard-date">
                          <FiClock />
                          Live monitoring
                        </div>

                      </div>


                      {/* METRICS */}
                      <div className="dashboard-metrics">

                        {/* CARD 1 */}
                        <div className="metric-card">

                          <div className="metric-card-top">

                            <span>
                              AI Tasks
                            </span>

                            <div className="metric-icon">
                              <FiCpu />
                            </div>

                          </div>

                          <div className="metric-value">
                            12,846
                          </div>

                          <div className="metric-growth">
                            <FiTrendingUp />
                            +24.8%
                            <span>
                              this month
                            </span>
                          </div>

                        </div>


                        {/* CARD 2 */}
                        <div className="metric-card">

                          <div className="metric-card-top">

                            <span>
                              Automation
                            </span>

                            <div className="metric-icon">
                              <FiZap />
                            </div>

                          </div>

                          <div className="metric-value">
                            94.6%
                          </div>

                          <div className="metric-growth">
                            <FiTrendingUp />
                            +8.2%
                            <span>
                              efficiency
                            </span>
                          </div>

                        </div>


                        {/* CARD 3 */}
                        <div className="metric-card metric-card-highlight">

                          <div className="metric-card-top">

                            <span>
                              Active Agents
                            </span>

                            <div className="metric-icon">
                              <FiActivity />
                            </div>

                          </div>

                          <div className="metric-value">
                            28
                          </div>

                          <div className="agent-status">
                            <span></span>
                            All systems operational
                          </div>

                        </div>

                      </div>


                      {/* =========================================
                          CHART + AGENT PANEL
                      ========================================== */}
                      <div className="dashboard-main-grid">

                        {/* CHART */}
                        <div className="dashboard-chart-card">

                          <div className="dashboard-card-heading">

                            <div>
                              <span>
                                AI ACTIVITY
                              </span>

                              <h4>
                                System performance
                              </h4>
                            </div>

                            <span className="chart-period">
                              7 days
                            </span>

                          </div>


                          <div className="fake-chart">

                            <div className="chart-y-axis">
                              <span>100</span>
                              <span>75</span>
                              <span>50</span>
                              <span>25</span>
                              <span>0</span>
                            </div>

                            <div className="chart-area">

                              <div className="chart-lines">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                              </div>

                              <svg
                                className="chart-svg"
                                viewBox="0 0 500 170"
                                preserveAspectRatio="none"
                              >
                                <defs>
                                  <linearGradient
                                    id="heroChartGradient"
                                    x1="0"
                                    y1="0"
                                    x2="1"
                                    y2="0"
                                  >
                                    <stop
                                      offset="0%"
                                      stopColor="#188cff"
                                    />

                                    <stop
                                      offset="100%"
                                      stopColor="#7055ee"
                                    />
                                  </linearGradient>
                                </defs>

                                <path
                                  d="M0,132 C35,120 48,125 72,112 C100,96 111,112 137,91 C160,73 180,92 205,76 C232,58 245,70 270,62 C300,52 313,70 338,47 C366,23 380,44 405,30 C431,15 450,28 500,8"
                                  fill="none"
                                  stroke="url(#heroChartGradient)"
                                  strokeWidth="4"
                                  strokeLinecap="round"
                                />

                                <path
                                  d="M0,132 C35,120 48,125 72,112 C100,96 111,112 137,91 C160,73 180,92 205,76 C232,58 245,70 270,62 C300,52 313,70 338,47 C366,23 380,44 405,30 C431,15 450,28 500,8 L500,170 L0,170 Z"
                                  fill="url(#heroChartGradient)"
                                  opacity="0.07"
                                />
                              </svg>

                              <div className="chart-x-axis">
                                <span>Mon</span>
                                <span>Tue</span>
                                <span>Wed</span>
                                <span>Thu</span>
                                <span>Fri</span>
                                <span>Sat</span>
                                <span>Sun</span>
                              </div>

                            </div>

                          </div>

                        </div>


                        {/* AGENTS */}
                        <div className="dashboard-agent-card">

                          <div className="dashboard-card-heading">

                            <div>
                              <span>
                                AI AGENTS
                              </span>

                              <h4>
                                Active now
                              </h4>
                            </div>

                            <span className="agent-count">
                              4
                            </span>

                          </div>


                          <div className="agent-list">

                            <div className="agent-row">

                              <div className="agent-avatar">
                                <FiMessageSquare />
                              </div>

                              <div className="agent-info">
                                <strong>
                                  Support Agent
                                </strong>

                                <span>
                                  Processing request
                                </span>
                              </div>

                              <span className="agent-live">
                                Live
                              </span>

                            </div>


                            <div className="agent-row">

                              <div className="agent-avatar">
                                <FiBarChart2 />
                              </div>

                              <div className="agent-info">
                                <strong>
                                  Analytics Agent
                                </strong>

                                <span>
                                  Analysing data
                                </span>
                              </div>

                              <span className="agent-live">
                                Live
                              </span>

                            </div>


                            <div className="agent-row">

                              <div className="agent-avatar">
                                <FiZap />
                              </div>

                              <div className="agent-info">
                                <strong>
                                  Automation Agent
                                </strong>

                                <span>
                                  Running workflow
                                </span>
                              </div>

                              <span className="agent-live">
                                Live
                              </span>

                            </div>

                          </div>

                        </div>

                      </div>


                      {/* =========================================
                          RECENT ACTIVITY
                      ========================================== */}
                      <div className="dashboard-activity">

                        <div className="activity-heading">
                          <div>
                            <span>
                              RECENT ACTIVITY
                            </span>

                            <h4>
                              System activity
                            </h4>
                          </div>

                          <span>
                            View all
                          </span>
                        </div>


                        <div className="activity-list">

                          <div className="activity-item">

                            <div className="activity-icon activity-blue">
                              <FiCpu />
                            </div>

                            <div className="activity-content">
                              <strong>
                                AI agent completed task
                              </strong>

                              <span>
                                Customer Support Agent
                              </span>
                            </div>

                            <time>
                              2m
                            </time>

                          </div>


                          <div className="activity-item">

                            <div className="activity-icon activity-purple">
                              <FiZap />
                            </div>

                            <div className="activity-content">
                              <strong>
                                Workflow automation completed
                              </strong>

                              <span>
                                Invoice processing
                              </span>
                            </div>

                            <time>
                              5m
                            </time>

                          </div>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>


                {/* FLOATING CARD */}
                <div className="dashboard-floating-card">

                  <div className="floating-card-icon">
                    <FiTrendingUp />
                  </div>

                  <div>
                    <span>
                      BUSINESS EFFICIENCY
                    </span>

                    <strong>
                      +38.4%
                    </strong>
                  </div>

                  <FiArrowUpRight />

                </div>

              </div>

            </div>

          </div>

        </section>

        {/* =====================================================
    HOME STATS
====================================================== */}
        <section className="home-stats-section">

          <div className="home-container">

            <div className="home-stats">

              {/* STAT 01 */}
              <div className="home-stat-item">

                <div className="home-stat-number">
                  AI<span>+</span>
                </div>

                <div className="home-stat-content">
                  <strong>
                    AI-Native
                  </strong>

                  <p>
                    Products designed around
                    artificial intelligence
                  </p>
                </div>

              </div>


              {/* STAT 02 */}
              <div className="home-stat-item">

                <div className="home-stat-number">
                  24<span>/</span>7
                </div>

                <div className="home-stat-content">
                  <strong>
                    Intelligent Automation
                  </strong>

                  <p>
                    Systems built to automate
                    repetitive workflows
                  </p>
                </div>

              </div>


              {/* STAT 03 */}
              <div className="home-stat-item">

                <div className="home-stat-number">
                  ∞
                </div>

                <div className="home-stat-content">
                  <strong>
                    Scalable Architecture
                  </strong>

                  <p>
                    Software designed to evolve
                    as businesses grow
                  </p>
                </div>

              </div>


              {/* STAT 04 */}
              <div className="home-stat-item">

                <div className="home-stat-number">
                  01
                </div>

                <div className="home-stat-content">
                  <strong>
                    Unified AI Platform
                  </strong>

                  <p>
                    AI, automation and intelligence
                    in one ecosystem
                  </p>
                </div>

              </div>

            </div>

          </div>

        </section>

        {/* =====================================================
    PLATFORM CAPABILITIES
====================================================== */}
        <section className="platform-capabilities-section">

          <div className="home-container">

            {/* SECTION HEADER */}
            <div className="platform-section-header">

              <div>
                <span className="section-eyebrow">
                  PLATFORM CAPABILITIES
                </span>

                <h2>
                  One intelligent platform.
                  <br />
                  <span>Built for what's next.</span>
                </h2>
              </div>

              <p>
                Dropgear IO brings AI, automation, data, and intelligent
                workflows together in a unified software environment
                designed to help modern businesses operate with greater
                speed and intelligence.
              </p>

            </div>


            {/* PLATFORM CONTENT */}
            <div className="platform-capabilities-grid">

              {/* =================================================
          LEFT CAPABILITIES
      ================================================== */}
              <div className="platform-capability-list">

                {/* CAPABILITY 01 */}
                <div className="platform-capability active">

                  <div className="platform-capability-number">
                    01
                  </div>

                  <div className="platform-capability-icon">
                    <FiCpu />
                  </div>

                  <div className="platform-capability-content">

                    <h3>
                      AI Intelligence
                    </h3>

                    <p>
                      Integrate intelligent models and AI-powered
                      decision systems into everyday business operations.
                    </p>

                  </div>

                  <FiArrowUpRight className="platform-capability-arrow" />

                </div>


                {/* CAPABILITY 02 */}
                <div className="platform-capability">

                  <div className="platform-capability-number">
                    02
                  </div>

                  <div className="platform-capability-icon">
                    <FiZap />
                  </div>

                  <div className="platform-capability-content">

                    <h3>
                      Workflow Automation
                    </h3>

                    <p>
                      Design automated workflows that connect processes,
                      applications, teams, and AI agents.
                    </p>

                  </div>

                  <FiArrowUpRight className="platform-capability-arrow" />

                </div>


                {/* CAPABILITY 03 */}
                <div className="platform-capability">

                  <div className="platform-capability-number">
                    03
                  </div>

                  <div className="platform-capability-icon">
                    <FiBarChart2 />
                  </div>

                  <div className="platform-capability-content">

                    <h3>
                      Business Intelligence
                    </h3>

                    <p>
                      Turn operational data into useful insights,
                      performance signals, and better decisions.
                    </p>

                  </div>

                  <FiArrowUpRight className="platform-capability-arrow" />

                </div>


                {/* CAPABILITY 04 */}
                <div className="platform-capability">

                  <div className="platform-capability-number">
                    04
                  </div>

                  <div className="platform-capability-icon">
                    <FiDatabase />
                  </div>

                  <div className="platform-capability-content">

                    <h3>
                      Connected Data
                    </h3>

                    <p>
                      Bring business information together so systems
                      and intelligent agents can work from connected data.
                    </p>

                  </div>

                  <FiArrowUpRight className="platform-capability-arrow" />

                </div>

              </div>


              {/* =================================================
          RIGHT DASHBOARD
      ================================================== */}
              <div className="platform-dashboard-wrapper">

                {/* DASHBOARD */}
                <div className="platform-dashboard">

                  {/* HEADER */}
                  <div className="platform-dashboard-header">

                    <div className="platform-dashboard-title">

                      <div className="platform-dashboard-logo">
                        <FiActivity />
                      </div>

                      <div>
                        <strong>
                          AI Operations
                        </strong>

                        <span>
                          Platform overview
                        </span>
                      </div>

                    </div>

                    <div className="platform-dashboard-status">
                      <span></span>
                      Operational
                    </div>

                  </div>


                  {/* BODY */}
                  <div className="platform-dashboard-body">

                    {/* TOP METRICS */}
                    <div className="platform-dashboard-metrics">

                      <div className="platform-metric">

                        <span>
                          ACTIVE AGENTS
                        </span>

                        <strong>
                          08
                        </strong>

                        <small>
                          <i></i>
                          Running
                        </small>

                      </div>


                      <div className="platform-metric">

                        <span>
                          WORKFLOWS
                        </span>

                        <strong>
                          124
                        </strong>

                        <small>
                          +12 this week
                        </small>

                      </div>


                      <div className="platform-metric">

                        <span>
                          AUTOMATION
                        </span>

                        <strong>
                          86.4%
                        </strong>

                        <small>
                          Efficiency
                        </small>

                      </div>

                    </div>


                    {/* MIDDLE GRID */}
                    <div className="platform-dashboard-middle">

                      {/* PERFORMANCE */}
                      <div className="platform-performance-card">

                        <div className="platform-card-title">

                          <div>
                            <span>
                              SYSTEM ACTIVITY
                            </span>

                            <h4>
                              Intelligence performance
                            </h4>
                          </div>

                          <span className="platform-time">
                            LIVE
                          </span>

                        </div>


                        <div className="platform-chart">

                          <div className="platform-chart-lines">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>

                          <svg
                            viewBox="0 0 600 180"
                            preserveAspectRatio="none"
                          >

                            <defs>

                              <linearGradient
                                id="platformLineGradient"
                                x1="0"
                                y1="0"
                                x2="1"
                                y2="0"
                              >

                                <stop
                                  offset="0%"
                                  stopColor="#1683ff"
                                />

                                <stop
                                  offset="100%"
                                  stopColor="#7457ee"
                                />

                              </linearGradient>

                            </defs>

                            <path
                              d="
                        M0 145
                        C35 140 45 122 75 128
                        C105 134 115 108 145 116
                        C180 126 192 86 225 94
                        C255 102 268 72 300 80
                        C330 88 345 56 375 66
                        C405 75 425 45 455 51
                        C490 60 520 28 550 35
                        C570 40 585 20 600 15
                      "
                              fill="none"
                              stroke="url(#platformLineGradient)"
                              strokeWidth="4"
                              strokeLinecap="round"
                            />

                            <path
                              d="
                        M0 145
                        C35 140 45 122 75 128
                        C105 134 115 108 145 116
                        C180 126 192 86 225 94
                        C255 102 268 72 300 80
                        C330 88 345 56 375 66
                        C405 75 425 45 455 51
                        C490 60 520 28 550 35
                        C570 40 585 20 600 15
                        L600 180
                        L0 180
                        Z
                      "
                              fill="url(#platformLineGradient)"
                              opacity="0.07"
                            />

                          </svg>

                          <div className="platform-chart-labels">
                            <span>Mon</span>
                            <span>Tue</span>
                            <span>Wed</span>
                            <span>Thu</span>
                            <span>Fri</span>
                            <span>Sat</span>
                            <span>Sun</span>
                          </div>

                        </div>

                      </div>


                      {/* AGENTS */}
                      <div className="platform-agents-card">

                        <div className="platform-card-title">

                          <div>
                            <span>
                              AI AGENTS
                            </span>

                            <h4>
                              Working now
                            </h4>
                          </div>

                          <FiMoreHorizontal />

                        </div>


                        <div className="platform-agent-list">

                          <div className="platform-agent">

                            <div className="platform-agent-icon">
                              <FiMessageSquare />
                            </div>

                            <div className="platform-agent-info">

                              <strong>
                                Support AI
                              </strong>

                              <span>
                                Handling requests
                              </span>

                            </div>

                            <i></i>

                          </div>


                          <div className="platform-agent">

                            <div className="platform-agent-icon">
                              <FiBarChart2 />
                            </div>

                            <div className="platform-agent-info">

                              <strong>
                                Analytics AI
                              </strong>

                              <span>
                                Analysing data
                              </span>

                            </div>

                            <i></i>

                          </div>


                          <div className="platform-agent">

                            <div className="platform-agent-icon">
                              <FiZap />
                            </div>

                            <div className="platform-agent-info">

                              <strong>
                                Workflow AI
                              </strong>

                              <span>
                                Running automation
                              </span>

                            </div>

                            <i></i>

                          </div>


                          <div className="platform-agent">

                            <div className="platform-agent-icon">
                              <FiDatabase />
                            </div>

                            <div className="platform-agent-info">

                              <strong>
                                Data AI
                              </strong>

                              <span>
                                Syncing information
                              </span>

                            </div>

                            <i></i>

                          </div>

                        </div>

                      </div>

                    </div>


                    {/* AUTOMATION FLOW */}
                    <div className="platform-automation-card">

                      <div className="platform-automation-heading">

                        <div>

                          <span>
                            AUTOMATION FLOW
                          </span>

                          <h4>
                            Order processing workflow
                          </h4>

                        </div>

                        <span className="automation-running">
                          Running
                        </span>

                      </div>


                      <div className="automation-flow">

                        <div className="automation-node completed">

                          <div>
                            <FiDatabase />
                          </div>

                          <span>
                            Order
                          </span>

                        </div>


                        <div className="automation-connector active"></div>


                        <div className="automation-node completed">

                          <div>
                            <FiCpu />
                          </div>

                          <span>
                            AI Check
                          </span>

                        </div>


                        <div className="automation-connector active"></div>


                        <div className="automation-node running">

                          <div>
                            <FiZap />
                          </div>

                          <span>
                            Process
                          </span>

                        </div>


                        <div className="automation-connector"></div>


                        <div className="automation-node">

                          <div>
                            <FiCheckCircle />
                          </div>

                          <span>
                            Complete
                          </span>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>


                {/* FLOATING BADGE */}
                <div className="platform-floating-card">

                  <div className="platform-floating-icon">
                    <FiZap />
                  </div>

                  <div>
                    <span>
                      AUTOMATED TASKS
                    </span>

                    <strong>
                      1,284
                    </strong>
                  </div>

                  <div className="platform-floating-up">
                    +18%
                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>


        {/* =====================================================
    HOW IT WORKS
===================================================== */}

        <section className="home-how-section">

          <div className="home-how-container">

            {/* SECTION HEADER */}
            <div className="home-how-header">

              <div className="home-how-heading">

                <span className="home-how-eyebrow">
                  HOW IT WORKS
                </span>

                <h2>
                  From business complexity
                  <br />
                  <span>to intelligent execution.</span>
                </h2>

              </div>


              <div className="home-how-intro">

                <p>
                  Dropgear IO connects your business data, workflows, AI
                  capabilities, and automation into one intelligent
                  operating environment.
                </p>

                <div className="home-how-note">
                  <FiCheckCircle />
                  <span>
                    Designed to work with your existing operations.
                  </span>
                </div>

              </div>

            </div>


            {/* =================================================
        WORKFLOW
    ================================================= */}

            <div className="home-how-flow">


              {/* STEP 01 */}
              <div className="home-how-step">

                <div className="home-how-step-top">

                  <span className="home-how-number">
                    01
                  </span>

                  <div className="home-how-icon">
                    <FiLink2 />
                  </div>

                </div>


                <div className="home-how-content">

                  <h3>
                    Connect Your Business
                  </h3>

                  <p>
                    Bring your existing tools, data, workflows, and
                    business processes into one connected SaaS
                    environment.
                  </p>

                  <ul>

                    <li>
                      <FiCheckCircle />
                      <span>Connect existing tools</span>
                    </li>

                    <li>
                      <FiCheckCircle />
                      <span>Centralize business data</span>
                    </li>

                    <li>
                      <FiCheckCircle />
                      <span>Configure your workspace</span>
                    </li>

                  </ul>

                </div>


                <div className="home-how-footer">

                  <span>
                    STEP 01
                  </span>

                  <FiArrowRight />

                </div>

              </div>


              {/* CONNECTOR */}

              <div className="home-how-connector">

                <span></span>

                <FiArrowRight />

              </div>


              {/* STEP 02 */}
              <div className="home-how-step">

                <div className="home-how-step-top">

                  <span className="home-how-number">
                    02
                  </span>

                  <div className="home-how-icon">
                    <FiCpu />
                  </div>

                </div>


                <div className="home-how-content">

                  <h3>
                    AI Understands
                  </h3>

                  <p>
                    Dropgear IO analyzes your business context and
                    identifies patterns across the way your teams
                    and processes operate.
                  </p>

                  <ul>

                    <li>
                      <FiCheckCircle />
                      <span>Understand business context</span>
                    </li>

                    <li>
                      <FiCheckCircle />
                      <span>Identify repetitive processes</span>
                    </li>

                    <li>
                      <FiCheckCircle />
                      <span>Discover useful patterns</span>
                    </li>

                  </ul>

                </div>


                <div className="home-how-footer">

                  <span>
                    STEP 02
                  </span>

                  <FiArrowRight />

                </div>

              </div>


              {/* CONNECTOR */}

              <div className="home-how-connector">

                <span></span>

                <FiArrowRight />

              </div>


              {/* STEP 03 */}
              <div className="home-how-step">

                <div className="home-how-step-top">

                  <span className="home-how-number">
                    03
                  </span>

                  <div className="home-how-icon">
                    <FiZap />
                  </div>

                </div>


                <div className="home-how-content">

                  <h3>
                    Automate the Work
                  </h3>

                  <p>
                    Turn repetitive operations into intelligent
                    workflows that can execute tasks and coordinate
                    actions automatically.
                  </p>

                  <ul>

                    <li>
                      <FiCheckCircle />
                      <span>Build intelligent workflows</span>
                    </li>

                    <li>
                      <FiCheckCircle />
                      <span>Automate repetitive tasks</span>
                    </li>

                    <li>
                      <FiCheckCircle />
                      <span>Coordinate actions automatically</span>
                    </li>

                  </ul>

                </div>


                <div className="home-how-footer">

                  <span>
                    STEP 03
                  </span>

                  <FiArrowRight />

                </div>

              </div>


              {/* CONNECTOR */}

              <div className="home-how-connector">

                <span></span>

                <FiArrowRight />

              </div>


              {/* STEP 04 */}
              <div className="home-how-step">

                <div className="home-how-step-top">

                  <span className="home-how-number">
                    04
                  </span>

                  <div className="home-how-icon">
                    <FiTrendingUp />
                  </div>

                </div>


                <div className="home-how-content">

                  <h3>
                    Optimize & Scale
                  </h3>

                  <p>
                    Monitor results, learn from operational data,
                    and continuously improve how your business
                    operates.
                  </p>

                  <ul>

                    <li>
                      <FiCheckCircle />
                      <span>Track workflow performance</span>
                    </li>

                    <li>
                      <FiCheckCircle />
                      <span>Find optimization opportunities</span>
                    </li>

                    <li>
                      <FiCheckCircle />
                      <span>Scale what works</span>
                    </li>

                  </ul>

                </div>


                <div className="home-how-footer">

                  <span>
                    STEP 04
                  </span>

                  <FiArrowRight />

                </div>

              </div>

            </div>


            {/* =================================================
        RESULT
    ================================================= */}

            <div className="home-how-result">

              <div className="home-how-result-line"></div>

              <div className="home-how-result-content">

                <div>

                  <span>
                    THE RESULT
                  </span>

                  <h3>
                    Your business keeps moving.
                    <br />

                    <strong>
                      AI handles the complexity.
                    </strong>
                  </h3>

                </div>


                <p>
                  Instead of adding another layer of software,
                  Dropgear IO is designed to become an intelligent
                  operating layer across your business.
                </p>

              </div>

            </div>

          </div>

        </section>

        {/* =====================================================
    TAILORED VERTICALS / INDUSTRIES
===================================================== */}

        <section className="home-verticals-section">

          <div className="home-verticals-container">

            {/* SECTION HEADER */}
            <div className="home-verticals-header">

              <div className="home-verticals-heading">

                <span className="home-verticals-eyebrow">
                  TAILORED VERTICALS
                </span>

                <h2>
                  Intelligence that understands
                  <br />
                  <span>how your industry operates.</span>
                </h2>

              </div>


              <div className="home-verticals-intro">

                <p>
                  Every industry has different workflows, decisions,
                  customers, and operational challenges. Dropgear IO adapts
                  AI-powered automation to the way your business actually
                  works.
                </p>

              </div>

            </div>


            {/* INDUSTRIES GRID */}

            <div className="home-verticals-grid">


              {/* RETAIL */}
              <div className="home-vertical-card">

                <div className="home-vertical-top">

                  <span className="home-vertical-number">
                    01
                  </span>

                  <div className="home-vertical-icon">
                    🛍
                  </div>

                </div>

                <div className="home-vertical-content">

                  <h3>
                    Retail & Ecommerce
                  </h3>

                  <p>
                    Automate customer interactions, order workflows,
                    inventory operations, and sales processes.
                  </p>

                </div>

                <div className="home-vertical-footer">

                  <span>
                    CUSTOMER & OPERATIONS
                  </span>

                  <span className="home-vertical-arrow">
                    →
                  </span>

                </div>

              </div>


              {/* HEALTHCARE */}
              <div className="home-vertical-card">

                <div className="home-vertical-top">

                  <span className="home-vertical-number">
                    02
                  </span>

                  <div className="home-vertical-icon">
                    🏥
                  </div>

                </div>

                <div className="home-vertical-content">

                  <h3>
                    Healthcare
                  </h3>

                  <p>
                    Streamline patient workflows, administrative
                    operations, scheduling, and service coordination.
                  </p>

                </div>

                <div className="home-vertical-footer">

                  <span>
                    PATIENT & OPERATIONS
                  </span>

                  <span className="home-vertical-arrow">
                    →
                  </span>

                </div>

              </div>


              {/* LOGISTICS */}
              <div className="home-vertical-card">

                <div className="home-vertical-top">

                  <span className="home-vertical-number">
                    03
                  </span>

                  <div className="home-vertical-icon">
                    🚚
                  </div>

                </div>

                <div className="home-vertical-content">

                  <h3>
                    Logistics
                  </h3>

                  <p>
                    Connect shipments, operations, communication,
                    tracking, and logistics workflows through automation.
                  </p>

                </div>

                <div className="home-vertical-footer">

                  <span>
                    FLOW & DELIVERY
                  </span>

                  <span className="home-vertical-arrow">
                    →
                  </span>

                </div>

              </div>


              {/* FINANCE */}
              <div className="home-vertical-card">

                <div className="home-vertical-top">

                  <span className="home-vertical-number">
                    04
                  </span>

                  <div className="home-vertical-icon">
                    💳
                  </div>

                </div>

                <div className="home-vertical-content">

                  <h3>
                    Finance
                  </h3>

                  <p>
                    Improve financial operations with intelligent
                    workflows for requests, reviews, reporting,
                    and recurring processes.
                  </p>

                </div>

                <div className="home-vertical-footer">

                  <span>
                    FINANCE & CONTROL
                  </span>

                  <span className="home-vertical-arrow">
                    →
                  </span>

                </div>

              </div>


              {/* PROFESSIONAL SERVICES */}
              <div className="home-vertical-card">

                <div className="home-vertical-top">

                  <span className="home-vertical-number">
                    05
                  </span>

                  <div className="home-vertical-icon">
                    💼
                  </div>

                </div>

                <div className="home-vertical-content">

                  <h3>
                    Professional Services
                  </h3>

                  <p>
                    Automate client operations, project workflows,
                    internal processes, and knowledge-driven tasks.
                  </p>

                </div>

                <div className="home-vertical-footer">

                  <span>
                    CLIENT & KNOWLEDGE
                  </span>

                  <span className="home-vertical-arrow">
                    →
                  </span>

                </div>

              </div>


              {/* ENTERPRISE */}
              <div className="home-vertical-card">

                <div className="home-vertical-top">

                  <span className="home-vertical-number">
                    06
                  </span>

                  <div className="home-vertical-icon">
                    🏢
                  </div>

                </div>

                <div className="home-vertical-content">

                  <h3>
                    Enterprise
                  </h3>

                  <p>
                    Build intelligent systems across complex teams,
                    departments, processes, and large-scale operations.
                  </p>

                </div>

                <div className="home-vertical-footer">

                  <span>
                    SCALE & GOVERNANCE
                  </span>

                  <span className="home-vertical-arrow">
                    →
                  </span>

                </div>

              </div>

            </div>


            {/* BOTTOM MESSAGE */}

            <div className="home-verticals-bottom">

              <div className="home-verticals-bottom-line"></div>

              <div className="home-verticals-bottom-content">

                <div>

                  <span>
                    ONE PLATFORM
                  </span>

                  <h3>
                    Different industries.
                    <br />
                    <strong>Intelligent workflows.</strong>
                  </h3>

                </div>

                <p>
                  Dropgear IO provides a common AI foundation while allowing
                  workflows, automations, and operational intelligence to
                  adapt to the specific needs of each industry.
                </p>

              </div>

            </div>

          </div>

        </section>

        {/* =====================================================
    AI-POWERED OPERATIONS
===================================================== */}

        <section className="home-ai-operations-section">

          <div className="home-ai-operations-container">

            {/* SECTION HEADER */}
            <div className="home-ai-operations-header">

              <div className="home-ai-operations-heading">

                <span className="home-ai-operations-eyebrow">
                  AI-POWERED OPERATIONS
                </span>

                <h2>
                  Experience a live view
                  <br />
                  <span>of intelligent operations.</span>
                </h2>

              </div>


              <div className="home-ai-operations-intro">

                <p>
                  Dropgear IO combines AI, automation, and business context
                  to help teams manage repetitive work, make faster
                  decisions, and keep operations moving.
                </p>

              </div>

            </div>


            {/* =================================================
        PRODUCT DASHBOARD
    ================================================= */}

            <div className="home-ai-product">

              {/* SIDEBAR */}

              <aside className="home-ai-sidebar">

                <div className="home-ai-brand">
                  <div className="home-ai-brand-mark">
                    <img src={logo} alt="dropgear" style={{ width: "30px", height: "30px" }} />
                  </div>

                  <span>
                    Dropgear IO
                  </span>
                </div>


                <div className="home-ai-sidebar-label">
                  WORKSPACE
                </div>


                <nav className="home-ai-sidebar-nav">

                  <div className="home-ai-nav-item active">
                    <span className="home-ai-nav-icon">⌂</span>
                    Overview
                  </div>

                  <div className="home-ai-nav-item">
                    <span className="home-ai-nav-icon">✦</span>
                    AI Workflows
                  </div>

                  <div className="home-ai-nav-item">
                    <span className="home-ai-nav-icon">↗</span>
                    Automations
                  </div>

                  <div className="home-ai-nav-item">
                    <span className="home-ai-nav-icon">◌</span>
                    Activity
                  </div>

                </nav>


                <div className="home-ai-sidebar-bottom">

                  <div className="home-ai-sidebar-label">
                    SYSTEM
                  </div>

                  <div className="home-ai-nav-item">
                    <span className="home-ai-nav-icon">⚙</span>
                    Settings
                  </div>

                </div>

              </aside>


              {/* MAIN DASHBOARD */}

              <main className="home-ai-dashboard">

                {/* DASHBOARD TOP */}

                <div className="home-ai-dashboard-top">

                  <div>

                    <span className="home-ai-dashboard-label">
                      OPERATIONS OVERVIEW
                    </span>

                    <h3>
                      Good morning Mr. Shyam, your AI is working.
                    </h3>

                  </div>


                  <div className="home-ai-status">

                    <span className="home-ai-status-dot"></span>

                    AI Systems Online

                  </div>

                </div>


                {/* METRICS */}

                <div className="home-ai-metrics">

                  <div className="home-ai-metric">

                    <span>
                      ACTIVE TASKS
                    </span>

                    <strong>
                      248
                    </strong>

                    <small>
                      +18% this week
                    </small>

                  </div>


                  <div className="home-ai-metric">

                    <span>
                      AUTOMATIONS
                    </span>

                    <strong>
                      36
                    </strong>

                    <small>
                      8 running now
                    </small>

                  </div>


                  <div className="home-ai-metric">

                    <span>
                      AI ACTIONS
                    </span>

                    <strong>
                      1,842
                    </strong>

                    <small>
                      +24% this month
                    </small>

                  </div>


                  <div className="home-ai-metric">

                    <span>
                      EFFICIENCY
                    </span>

                    <strong>
                      91%
                    </strong>

                    <small>
                      workflow efficiency
                    </small>

                  </div>

                </div>


                {/* DASHBOARD GRID */}

                <div className="home-ai-dashboard-grid">


                  {/* WORKFLOW CARD */}

                  <div className="home-ai-workflow-card">

                    <div className="home-ai-card-header">

                      <div>

                        <span>
                          AI WORKFLOW
                        </span>

                        <h4>
                          Customer Order Processing
                        </h4>

                      </div>

                      <div className="home-ai-running">
                        Running
                      </div>

                    </div>


                    {/* WORKFLOW */}

                    <div className="home-ai-workflow">

                      <div className="home-ai-workflow-step">

                        <div className="home-ai-workflow-icon">
                          1
                        </div>

                        <div>
                          <strong>
                            New Order
                          </strong>

                          <small>
                            Order received
                          </small>
                        </div>

                      </div>


                      <div className="home-ai-workflow-line"></div>


                      <div className="home-ai-workflow-step">

                        <div className="home-ai-workflow-icon ai">
                          ✦
                        </div>

                        <div>
                          <strong>
                            AI Analysis
                          </strong>

                          <small>
                            Processing order context
                          </small>
                        </div>

                      </div>


                      <div className="home-ai-workflow-line"></div>


                      <div className="home-ai-workflow-step">

                        <div className="home-ai-workflow-icon">
                          3
                        </div>

                        <div>
                          <strong>
                            Inventory Check
                          </strong>

                          <small>
                            Availability confirmed
                          </small>
                        </div>

                      </div>


                      <div className="home-ai-workflow-line"></div>


                      <div className="home-ai-workflow-step">

                        <div className="home-ai-workflow-icon success">
                          ✓
                        </div>

                        <div>
                          <strong>
                            Action Completed
                          </strong>

                          <small>
                            Customer notified
                          </small>
                        </div>

                      </div>

                    </div>

                  </div>


                  {/* AI ACTIVITY */}

                  <div className="home-ai-activity-card">

                    <div className="home-ai-card-header">

                      <div>

                        <span>
                          AI ACTIVITY
                        </span>

                        <h4>
                          Recent Actions
                        </h4>

                      </div>

                      <span className="home-ai-live">
                        LIVE
                      </span>

                    </div>


                    <div className="home-ai-activity-list">

                      <div className="home-ai-activity">

                        <div className="home-ai-activity-icon">
                          ✦
                        </div>

                        <div>

                          <strong>
                            Workflow completed
                          </strong>

                          <small>
                            Order processing automation
                          </small>

                        </div>

                        <span>
                          2m
                        </span>

                      </div>


                      <div className="home-ai-activity">

                        <div className="home-ai-activity-icon">
                          ↗
                        </div>

                        <div>

                          <strong>
                            Task automated
                          </strong>

                          <small>
                            Customer follow-up
                          </small>

                        </div>

                        <span>
                          8m
                        </span>

                      </div>


                      <div className="home-ai-activity">

                        <div className="home-ai-activity-icon">
                          ✓
                        </div>

                        <div>

                          <strong>
                            Decision completed
                          </strong>

                          <small>
                            Inventory validation
                          </small>

                        </div>

                        <span>
                          14m
                        </span>

                      </div>


                      <div className="home-ai-activity">

                        <div className="home-ai-activity-icon">
                          ✦
                        </div>

                        <div>

                          <strong>
                            AI insight generated
                          </strong>

                          <small>
                            Operations optimization
                          </small>

                        </div>

                        <span>
                          21m
                        </span>

                      </div>

                    </div>

                  </div>

                </div>


                {/* AI INSIGHT */}

                <div className="home-ai-insight">

                  <div className="home-ai-insight-icon">
                    ✦
                  </div>

                  <div className="home-ai-insight-content">

                    <span>
                      AI INSIGHT
                    </span>

                    <strong>
                      Dropgear IO detected 12 repetitive tasks
                      that could be automated.
                    </strong>

                    <small>
                      Estimated operational time saved:
                      18.5 hours this week.
                    </small>

                  </div>

                  <div className="home-ai-insight-action">
                    Review →
                  </div>

                </div>

              </main>

            </div>


            {/* =================================================
        CAPABILITIES BELOW DASHBOARD
    ================================================= */}

            <div className="home-ai-capabilities">

              <div className="home-ai-capability">

                <div className="home-ai-capability-icon">
                  ✦
                </div>

                <div>

                  <h3>
                    AI Workflow Automation
                  </h3>

                  <p>
                    Automate repetitive operational processes
                    without disrupting existing workflows.
                  </p>

                </div>

              </div>


              <div className="home-ai-capability">

                <div className="home-ai-capability-icon">
                  ◈
                </div>

                <div>

                  <h3>
                    Intelligent Decisions
                  </h3>

                  <p>
                    Turn business data and context into useful
                    operational decisions and insights.
                  </p>

                </div>

              </div>


              <div className="home-ai-capability">

                <div className="home-ai-capability-icon">
                  ◎
                </div>

                <div>

                  <h3>
                    AI Agents
                  </h3>

                  <p>
                    Let intelligent systems execute defined
                    tasks and coordinate actions across workflows.
                  </p>

                </div>

              </div>


              <div className="home-ai-capability">

                <div className="home-ai-capability-icon">
                  ↗
                </div>

                <div>

                  <h3>
                    Continuous Optimization
                  </h3>

                  <p>
                    Monitor results and continuously improve
                    operational performance.
                  </p>

                </div>

              </div>

            </div>

          </div>

        </section>

        {/* =====================================================
    AI AGENTS
===================================================== */}

        <section className="home-ai-agents-section">

          <div className="home-ai-agents-container">

            {/* SECTION HEADER */}
            <div className="home-ai-agents-header">

              <div className="home-ai-agents-heading">

                <span className="home-ai-agents-eyebrow">
                  INTELLIGENT AI AGENTS
                </span>

                <h2>
                  AI Agents That Move
                  <br />
                  <span>Work Forward.</span>
                </h2>

              </div>

              <div className="home-ai-agents-intro">

                <p>
                  Dropgear AI agents understand business context,
                  make decisions, and execute defined tasks across
                  your operational workflows.
                </p>

              </div>

            </div>


            {/* =================================================
        AGENT EXPERIENCE
    ================================================= */}

            <div className="home-ai-agent-platform">


              {/* LEFT — AGENT FLOW */}

              <div className="home-ai-agent-flow">

                <div className="home-ai-flow-label">
                  HOW AN AI AGENT WORKS
                </div>

                <h3>
                  From understanding
                  <br />
                  to action.
                </h3>

                <p className="home-ai-flow-description">
                  AI agents don't just generate responses.
                  They understand context, reason through
                  tasks, and take action within defined
                  business workflows.
                </p>


                {/* FLOW */}

                <div className="home-ai-flow">

                  {/* UNDERSTAND */}

                  <div className="home-ai-flow-item">

                    <div className="home-ai-flow-number">
                      01
                    </div>

                    <div className="home-ai-flow-icon">
                      ◉
                    </div>

                    <div className="home-ai-flow-content">

                      <h4>
                        Understand
                      </h4>

                      <p>
                        Read incoming information,
                        context, and business signals.
                      </p>

                    </div>

                  </div>


                  <div className="home-ai-flow-connector"></div>


                  {/* REASON */}

                  <div className="home-ai-flow-item">

                    <div className="home-ai-flow-number">
                      02
                    </div>

                    <div className="home-ai-flow-icon purple">
                      ✦
                    </div>

                    <div className="home-ai-flow-content">

                      <h4>
                        Reason
                      </h4>

                      <p>
                        Evaluate context and determine
                        the appropriate next action.
                      </p>

                    </div>

                  </div>


                  <div className="home-ai-flow-connector"></div>


                  {/* ACT */}

                  <div className="home-ai-flow-item">

                    <div className="home-ai-flow-number">
                      03
                    </div>

                    <div className="home-ai-flow-icon green">
                      ↗
                    </div>

                    <div className="home-ai-flow-content">

                      <h4>
                        Act
                      </h4>

                      <p>
                        Execute approved tasks through
                        connected business workflows.
                      </p>

                    </div>

                  </div>


                  <div className="home-ai-flow-connector"></div>


                  {/* OPTIMIZE */}

                  <div className="home-ai-flow-item">

                    <div className="home-ai-flow-number">
                      04
                    </div>

                    <div className="home-ai-flow-icon orange">
                      ↻
                    </div>

                    <div className="home-ai-flow-content">

                      <h4>
                        Optimize
                      </h4>

                      <p>
                        Learn from operational outcomes
                        and improve future actions.
                      </p>

                    </div>

                  </div>

                </div>

              </div>


              {/* RIGHT — AGENT CARD */}

              <div className="home-ai-agent-showcase">

                <div className="home-ai-agent-glow"></div>


                {/* CARD */}

                <div className="home-ai-agent-card">

                  {/* CARD TOP */}

                  <div className="home-ai-agent-card-top">

                    <div className="home-ai-agent-card-title">

                      <div className="home-ai-agent-avatar">
                        ✦
                      </div>

                      <div>

                        <span>
                          AI AGENT
                        </span>

                        <h3>
                          Customer Operations Agent
                        </h3>

                      </div>

                    </div>


                    <div className="home-ai-agent-active">

                      <span></span>

                      Active

                    </div>

                  </div>


                  {/* AGENT DESCRIPTION */}

                  <p className="home-ai-agent-card-description">
                    Handles incoming customer requests,
                    understands intent, checks relevant
                    information, and initiates the appropriate
                    workflow.
                  </p>


                  {/* AGENT TASK */}

                  <div className="home-ai-agent-task">

                    <div className="home-ai-task-heading">

                      <span>
                        CURRENT TASK
                      </span>

                      <small>
                        Processing
                      </small>

                    </div>

                    <h4>
                      Resolve customer order issue
                    </h4>

                    <div className="home-ai-progress">

                      <div className="home-ai-progress-bar"></div>

                    </div>

                    <div className="home-ai-progress-info">

                      <span>
                        Understanding request
                      </span>

                      <span>
                        68%
                      </span>

                    </div>

                  </div>


                  {/* AGENT ACTIONS */}

                  <div className="home-ai-agent-actions">

                    <div className="home-ai-agent-action-title">
                      AGENT ACTIVITY
                    </div>


                    <div className="home-ai-agent-action">

                      <div className="home-ai-action-check">
                        ✓
                      </div>

                      <div>
                        <strong>
                          Customer request analyzed
                        </strong>

                        <small>
                          Intent identified
                        </small>
                      </div>

                      <span>
                        Done
                      </span>

                    </div>


                    <div className="home-ai-agent-action">

                      <div className="home-ai-action-check">
                        ✓
                      </div>

                      <div>
                        <strong>
                          Order information retrieved
                        </strong>

                        <small>
                          Data context available
                        </small>
                      </div>

                      <span>
                        Done
                      </span>

                    </div>


                    <div className="home-ai-agent-action current">

                      <div className="home-ai-action-ai">
                        ✦
                      </div>

                      <div>
                        <strong>
                          Determining next action
                        </strong>

                        <small>
                          AI reasoning in progress
                        </small>
                      </div>

                      <span>
                        Working
                      </span>

                    </div>

                  </div>


                  {/* CARD FOOTER */}

                  <div className="home-ai-agent-footer">

                    <div>

                      <span>
                        TASKS COMPLETED
                      </span>

                      <strong>
                        1,284
                      </strong>

                    </div>

                    <div>

                      <span>
                        SUCCESS RATE
                      </span>

                      <strong>
                        96.8%
                      </strong>

                    </div>

                    <div>

                      <span>
                        AVG. RESPONSE
                      </span>

                      <strong>
                        1.8s
                      </strong>

                    </div>

                  </div>

                </div>

              </div>

            </div>


            {/* =================================================
        AGENT TYPES
    ================================================= */}

            <div className="home-ai-agent-types">

              <div className="home-ai-agent-type">

                <div className="home-ai-agent-type-icon">
                  ◉
                </div>

                <div>

                  <h3>
                    Customer Agents
                  </h3>

                  <p>
                    Understand requests and automate
                    customer-facing workflows.
                  </p>

                </div>

              </div>


              <div className="home-ai-agent-type">

                <div className="home-ai-agent-type-icon purple">
                  ✦
                </div>

                <div>

                  <h3>
                    Operations Agents
                  </h3>

                  <p>
                    Coordinate repetitive tasks and
                    operational processes.
                  </p>

                </div>

              </div>


              <div className="home-ai-agent-type">

                <div className="home-ai-agent-type-icon green">
                  ↗
                </div>

                <div>

                  <h3>
                    Workflow Agents
                  </h3>

                  <p>
                    Connect actions across systems
                    and business workflows.
                  </p>

                </div>

              </div>


              <div className="home-ai-agent-type">

                <div className="home-ai-agent-type-icon orange">
                  ◇
                </div>

                <div>

                  <h3>
                    Decision Agents
                  </h3>

                  <p>
                    Analyze business context and
                    support faster operational decisions.
                  </p>

                </div>

              </div>

            </div>

          </div>

        </section>

        {/* =====================================================
    WHY DROPGEAR
===================================================== */}

        <section className="why-dropgear-section">

          <div className="why-dropgear-container">

            {/* HEADER */}

            <div className="why-dropgear-header">

              <div className="why-dropgear-heading">

                <span className="why-dropgear-eyebrow">
                  WHY DROPGEAR IO
                </span>

                <h2>
                  Built for work
                  <br />
                  <span>that can't stand still.</span>
                </h2>

              </div>

              <div className="why-dropgear-intro">

                <p>
                  Modern businesses move fast. Dropgear IO combines
                  intelligent AI, automation, and operational context
                  to help teams move from repetitive work to meaningful
                  progress.
                </p>

              </div>

            </div>


            {/* =================================================
        MAIN BENEFITS
    ================================================= */}

            <div className="why-dropgear-grid">


              {/* BENEFIT 01 */}

              <div className="why-dropgear-card featured">

                <div className="why-dropgear-card-top">

                  <span className="why-dropgear-number">
                    01
                  </span>

                  <div className="why-dropgear-icon blue">
                    ✦
                  </div>

                </div>

                <h3>
                  AI that understands
                  <br />
                  your business.
                </h3>

                <p>
                  Dropgear IO AI works with business context, workflows,
                  and operational data to deliver actions that are more
                  relevant than generic automation.
                </p>

                <div className="why-dropgear-visual context-visual">

                  <div className="context-main-node">
                    <span>✦</span>
                    <strong>AI Context</strong>
                  </div>

                  <div className="context-line line-one"></div>
                  <div className="context-line line-two"></div>
                  <div className="context-line line-three"></div>

                  <div className="context-node node-one">
                    Customer
                  </div>

                  <div className="context-node node-two">
                    Workflow
                  </div>

                  <div className="context-node node-three">
                    Data
                  </div>

                </div>

              </div>


              {/* BENEFIT 02 */}

              <div className="why-dropgear-card">

                <div className="why-dropgear-card-top">

                  <span className="why-dropgear-number">
                    02
                  </span>

                  <div className="why-dropgear-icon purple">
                    ↗
                  </div>

                </div>

                <h3>
                  From insight
                  <br />
                  to action.
                </h3>

                <p>
                  Go beyond dashboards and recommendations. AI agents
                  can identify what needs attention and move approved
                  workflows forward.
                </p>

                <div className="why-dropgear-action-visual">

                  <div className="action-step completed">
                    <span>✓</span>
                    Analyze
                  </div>

                  <div className="action-arrow">
                    ↓
                  </div>

                  <div className="action-step active">
                    <span>✦</span>
                    Decide
                  </div>

                  <div className="action-arrow">
                    ↓
                  </div>

                  <div className="action-step">
                    <span>↗</span>
                    Execute
                  </div>

                </div>

              </div>


              {/* BENEFIT 03 */}

              <div className="why-dropgear-card">

                <div className="why-dropgear-card-top">

                  <span className="why-dropgear-number">
                    03
                  </span>

                  <div className="why-dropgear-icon green">
                    ◎
                  </div>

                </div>

                <h3>
                  Designed to work
                  <br />
                  with your systems.
                </h3>

                <p>
                  Connect Dropgear IO with the tools, workflows, and
                  operational systems your teams already rely on.
                </p>

                <div className="why-dropgear-system-visual">

                  <div className="system-center">
                    DG
                  </div>

                  <div className="system-orbit orbit-one"></div>
                  <div className="system-orbit orbit-two"></div>

                  <div className="system-node system-one">
                    CRM
                  </div>

                  <div className="system-node system-two">
                    ERP
                  </div>

                  <div className="system-node system-three">
                    DATA
                  </div>

                  <div className="system-node system-four">
                    API
                  </div>

                </div>

              </div>


              {/* BENEFIT 04 */}

              <div className="why-dropgear-card wide-card">

                <div className="why-dropgear-wide-content">

                  <div>

                    <div className="why-dropgear-card-top">

                      <span className="why-dropgear-number">
                        04
                      </span>

                      <div className="why-dropgear-icon orange">
                        ◇
                      </div>

                    </div>

                    <h3>
                      Built to grow with your operations.
                    </h3>

                    <p>
                      Start with focused workflows and expand AI
                      capabilities as your business processes,
                      teams, and operational requirements evolve.
                    </p>

                  </div>


                  {/* SCALE VISUAL */}

                  <div className="why-dropgear-scale-visual">

                    <div className="scale-label">
                      OPERATIONAL SCALE
                    </div>

                    <div className="scale-bars">

                      <div className="scale-bar">
                        <span>01</span>
                        <div></div>
                      </div>

                      <div className="scale-bar">
                        <span>02</span>
                        <div></div>
                      </div>

                      <div className="scale-bar active">
                        <span>03</span>
                        <div></div>
                      </div>

                      <div className="scale-bar">
                        <span>04</span>
                        <div></div>
                      </div>

                    </div>

                    <div className="scale-footer">

                      <span>
                        Today
                      </span>

                      <strong>
                        Ready to expand
                      </strong>

                    </div>

                  </div>

                </div>

              </div>

            </div>


            {/* =================================================
        BOTTOM MESSAGE
    ================================================= */}

            <div className="why-dropgear-bottom">

              <div className="why-dropgear-bottom-mark">
                ✦
              </div>

              <p>
                Less repetitive work. More intelligent progress.
              </p>

              <span>
                Built for modern teams and evolving operations.
              </span>

            </div>

          </div>

        </section>


        {/* =====================================================
    SECURITY & TRUST
===================================================== */}

        <section className="security-trust-section">

          <div className="security-trust-container">

            {/* =================================================
        HEADER
    ================================================= */}

            <div className="security-trust-header">

              <div className="security-trust-heading">

                <span className="security-trust-eyebrow">
                  SECURITY & TRUST
                </span>

                <h2>
                  Intelligence you can
                  <br />
                  <span>put in control.</span>
                </h2>

              </div>

              <div className="security-trust-intro">

                <p>
                  Dropgear IO is being designed with security,
                  visibility, permissions, and human oversight
                  at the core of AI-powered operations.
                </p>

              </div>

            </div>


            {/* =================================================
        MAIN SECURITY AREA
    ================================================= */}

            <div className="security-trust-main">


              {/* =================================================
          LEFT — SECURITY VISUAL
      ================================================= */}

              <div className="security-trust-visual">

                <div className="security-visual-glow"></div>

                <div className="security-grid-pattern"></div>


                {/* SECURITY CORE */}

                <div className="security-core">

                  <div className="security-core-ring">

                    <div className="security-core-icon">
                      ✓
                    </div>

                  </div>

                  <span>
                    DROPGEAR IO
                  </span>

                  <strong>
                    Controlled AI Operations
                  </strong>

                </div>


                {/* TOP NODE */}

                <div className="security-node security-node-top">

                  <div className="security-node-icon">
                    ✓
                  </div>

                  <div>

                    <strong>
                      Access Control
                    </strong>

                    <span>
                      Defined permissions
                    </span>

                  </div>

                </div>


                {/* LEFT NODE */}

                <div className="security-node security-node-left">

                  <div className="security-node-icon purple">
                    ◈
                  </div>

                  <div>

                    <strong>
                      Data Awareness
                    </strong>

                    <span>
                      Context-based access
                    </span>

                  </div>

                </div>


                {/* RIGHT NODE */}

                <div className="security-node security-node-right">

                  <div className="security-node-icon green">
                    ✓
                  </div>

                  <div>

                    <strong>
                      Human Oversight
                    </strong>

                    <span>
                      Approval when needed
                    </span>

                  </div>

                </div>


                {/* BOTTOM NODE */}

                <div className="security-node security-node-bottom">

                  <div className="security-node-icon orange">
                    ◇
                  </div>

                  <div>

                    <strong>
                      Activity Visibility
                    </strong>

                    <span>
                      Understand workflows
                    </span>

                  </div>

                </div>


                {/* CONNECTION LINES */}

                <div className="security-connection connection-top"></div>

                <div className="security-connection connection-left"></div>

                <div className="security-connection connection-right"></div>

                <div className="security-connection connection-bottom"></div>

              </div>


              {/* =================================================
          RIGHT — SECURITY PRINCIPLES
      ================================================= */}

              <div className="security-trust-content">


                {/* 01 */}

                <div className="security-trust-item">

                  <div className="security-trust-item-number">
                    01
                  </div>

                  <div className="security-trust-item-icon">
                    ◈
                  </div>

                  <div className="security-trust-item-body">

                    <h3>
                      Controlled access
                    </h3>

                    <p>
                      Design workflows so people and AI systems
                      can work within clearly defined permissions
                      and responsibilities.
                    </p>

                  </div>

                </div>


                {/* 02 */}

                <div className="security-trust-item">

                  <div className="security-trust-item-number">
                    02
                  </div>

                  <div className="security-trust-item-icon purple">
                    ✓
                  </div>

                  <div className="security-trust-item-body">

                    <h3>
                      Human oversight
                    </h3>

                    <p>
                      Keep people involved where decisions,
                      approvals, or business policies require
                      human judgment.
                    </p>

                  </div>

                </div>


                {/* 03 */}

                <div className="security-trust-item">

                  <div className="security-trust-item-number">
                    03
                  </div>

                  <div className="security-trust-item-icon green">
                    ◉
                  </div>

                  <div className="security-trust-item-body">

                    <h3>
                      Operational visibility
                    </h3>

                    <p>
                      Make important AI-driven workflows easier
                      to understand by providing visibility into
                      actions and process status.
                    </p>

                  </div>

                </div>


                {/* 04 */}

                <div className="security-trust-item">

                  <div className="security-trust-item-number">
                    04
                  </div>

                  <div className="security-trust-item-icon orange">
                    ↗
                  </div>

                  <div className="security-trust-item-body">

                    <h3>
                      Responsible automation
                    </h3>

                    <p>
                      Automate defined tasks while keeping
                      business rules, workflow boundaries, and
                      human decisions at the center.
                    </p>

                  </div>

                </div>


              </div>

            </div>


            {/* =================================================
        TRUST PRINCIPLES
    ================================================= */}

            <div className="security-trust-strip">


              {/* ITEM 01 */}

              <div className="security-trust-strip-item">

                <div className="security-strip-icon">
                  ✓
                </div>

                <div>

                  <strong>
                    Permission-aware
                  </strong>

                  <span>
                    Work within defined access boundaries
                  </span>

                </div>

              </div>


              {/* ITEM 02 */}

              <div className="security-trust-strip-item">

                <div className="security-strip-icon purple">
                  ◈
                </div>

                <div>

                  <strong>
                    Transparent
                  </strong>

                  <span>
                    Visibility into important workflows
                  </span>

                </div>

              </div>


              {/* ITEM 03 */}

              <div className="security-trust-strip-item">

                <div className="security-strip-icon green">
                  ✓
                </div>

                <div>

                  <strong>
                    Human-led
                  </strong>

                  <span>
                    People remain part of important decisions
                  </span>

                </div>

              </div>


              {/* ITEM 04 */}

              <div className="security-trust-strip-item">

                <div className="security-strip-icon orange">
                  ◇
                </div>

                <div>

                  <strong>
                    Designed responsibly
                  </strong>

                  <span>
                    Automation with defined boundaries
                  </span>

                </div>

              </div>


            </div>


            {/* =================================================
        BOTTOM MESSAGE
    ================================================= */}

            <div className="security-trust-bottom">

              <div className="security-trust-bottom-icon">
                ✦
              </div>

              <div>

                <h3>
                  AI that works with clarity.
                </h3>

                <p>
                  Built around visibility, control, and responsible
                  automation as Dropgear evolves.
                </p>

              </div>

            </div>

          </div>

        </section>

        {/* =====================================================
    FAQ SECTION
===================================================== */}

        <section className="home-faq-section">

          <div className="home-faq-container">

            {/* =================================================
        FAQ HEADER
    ================================================= */}

            <div className="home-faq-header">

              <div>

                <span className="home-faq-eyebrow">
                  FREQUENTLY ASKED QUESTIONS
                </span>

                <h2>
                  Questions before you
                  <br />
                  <span>start building.</span>
                </h2>

              </div>

              <div className="home-faq-intro">

                <p>
                  Explore how Dropgear IO helps teams introduce AI
                  into everyday operations, connect existing tools,
                  and build practical workflows without unnecessary
                  complexity.
                </p>

              </div>

            </div>


            {/* =================================================
        FAQ TABS
    ================================================= */}

            <div className="home-faq-tabs">

              <button
                className={
                  activeFaqTab === "capabilities"
                    ? "active"
                    : ""
                }
                onClick={() =>
                  setActiveFaqTab("capabilities")
                }
              >
                Capabilities
              </button>

              <button
                className={
                  activeFaqTab === "integrations"
                    ? "active"
                    : ""
                }
                onClick={() =>
                  setActiveFaqTab("integrations")
                }
              >
                Integrations
              </button>

              <button
                className={
                  activeFaqTab === "setup"
                    ? "active"
                    : ""
                }
                onClick={() =>
                  setActiveFaqTab("setup")
                }
              >
                Setup
              </button>

              <button
                className={
                  activeFaqTab === "ai"
                    ? "active"
                    : ""
                }
                onClick={() =>
                  setActiveFaqTab("ai")
                }
              >
                AI & Automation
              </button>

              <button
                className={
                  activeFaqTab === "business"
                    ? "active"
                    : ""
                }
                onClick={() =>
                  setActiveFaqTab("business")
                }
              >
                Business
              </button>

            </div>


            {/* =================================================
        FAQ CONTENT
    ================================================= */}

            <div className="home-faq-content">


              {/* =================================================
          CAPABILITIES
      ================================================= */}

              {activeFaqTab === "capabilities" && (

                <div className="home-faq-list">

                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "cap-1"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "cap-1"
                            ? null
                            : "cap-1"
                        )
                      }
                    >

                      <span>
                        What can Dropgear IO help businesses automate?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "cap-1" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "cap-1" && (

                      <div className="home-faq-answer">

                        <p>
                          Dropgear IO is designed to help businesses
                          automate repetitive operational work such
                          as customer interactions, information
                          processing, workflow coordination, task
                          routing, and other recurring processes.
                        </p>

                      </div>

                    )}

                  </div>


                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "cap-2"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "cap-2"
                            ? null
                            : "cap-2"
                        )
                      }
                    >

                      <span>
                        Can Dropgear IO support different business workflows?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "cap-2" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "cap-2" && (

                      <div className="home-faq-answer">

                        <p>
                          Yes. Dropgear IO is designed around configurable
                          workflows so different teams can adapt
                          automation to their own processes,
                          responsibilities, and operational requirements.
                        </p>

                      </div>

                    )}

                  </div>


                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "cap-3"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "cap-3"
                            ? null
                            : "cap-3"
                        )
                      }
                    >

                      <span>
                        Can teams use AI agents for operational tasks?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "cap-3" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "cap-3" && (

                      <div className="home-faq-answer">

                        <p>
                          Dropgear IO is being designed to support AI
                          agents that can perform defined tasks,
                          coordinate workflow steps, and help move
                          operational processes forward while keeping
                          appropriate human oversight.
                        </p>

                      </div>

                    )}

                  </div>

                </div>

              )}


              {/* =================================================
          INTEGRATIONS
      ================================================= */}

              {activeFaqTab === "integrations" && (

                <div className="home-faq-list">

                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "int-1"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "int-1"
                            ? null
                            : "int-1"
                        )
                      }
                    >

                      <span>
                        Can Dropgear IO connect with existing business tools?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "int-1" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "int-1" && (

                      <div className="home-faq-answer">

                        <p>
                          Dropgear IO is designed to work alongside the
                          tools businesses already use. Integrations
                          can connect business applications, data,
                          communication channels, and operational
                          workflows.
                        </p>

                      </div>

                    )}

                  </div>


                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "int-2"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "int-2"
                            ? null
                            : "int-2"
                        )
                      }
                    >

                      <span>
                        What types of systems can be integrated?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "int-2" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "int-2" && (

                      <div className="home-faq-answer">

                        <p>
                          Depending on the workflow, integrations may
                          include CRM platforms, communication tools,
                          business applications, databases, APIs, and
                          other systems used by your organization.
                        </p>

                      </div>

                    )}

                  </div>


                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "int-3"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "int-3"
                            ? null
                            : "int-3"
                        )
                      }
                    >

                      <span>
                        Can Dropgear IO work with APIs?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "int-3" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "int-3" && (

                      <div className="home-faq-answer">

                        <p>
                          API-based connections can be used to connect
                          Dropgear IO workflows with external applications
                          and business systems where supported.
                        </p>

                      </div>

                    )}

                  </div>

                </div>

              )}


              {/* =================================================
          SETUP
      ================================================= */}

              {activeFaqTab === "setup" && (

                <div className="home-faq-list">

                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "setup-1"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "setup-1"
                            ? null
                            : "setup-1"
                        )
                      }
                    >

                      <span>
                        How do we get started with Dropgear IO?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "setup-1" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "setup-1" && (

                      <div className="home-faq-answer">

                        <p>
                          Start by identifying a workflow where
                          automation can create measurable value.
                          From there, the workflow can be mapped,
                          configured, connected to the required
                          systems, and gradually introduced into
                          your operations.
                        </p>

                      </div>

                    )}

                  </div>


                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "setup-2"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "setup-2"
                            ? null
                            : "setup-2"
                        )
                      }
                    >

                      <span>
                        Do we need a technical team to use Dropgear IO?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "setup-2" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "setup-2" && (

                      <div className="home-faq-answer">

                        <p>
                          Dropgear IO is intended to make AI-powered
                          workflows easier for business teams to
                          configure and operate. Technical support
                          may still be useful for more advanced
                          integrations and custom requirements.
                        </p>

                      </div>

                    )}

                  </div>


                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "setup-3"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "setup-3"
                            ? null
                            : "setup-3"
                        )
                      }
                    >

                      <span>
                        Can we start with one workflow first?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "setup-3" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "setup-3" && (

                      <div className="home-faq-answer">

                        <p>
                          Yes. Starting with a focused workflow can
                          help teams understand the value of automation
                          before expanding into additional processes.
                        </p>

                      </div>

                    )}

                  </div>

                </div>

              )}


              {/* =================================================
          AI & AUTOMATION
      ================================================= */}

              {activeFaqTab === "ai" && (

                <div className="home-faq-list">

                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "ai-1"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "ai-1"
                            ? null
                            : "ai-1"
                        )
                      }
                    >

                      <span>
                        How does AI fit into Dropgear IO workflows?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "ai-1" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "ai-1" && (

                      <div className="home-faq-answer">

                        <p>
                          AI can be introduced at specific points
                          within a workflow to understand information,
                          generate responses, make recommendations,
                          classify inputs, or perform defined actions.
                        </p>

                      </div>

                    )}

                  </div>


                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "ai-2"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "ai-2"
                            ? null
                            : "ai-2"
                        )
                      }
                    >

                      <span>
                        Are AI agents fully autonomous?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "ai-2" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "ai-2" && (

                      <div className="home-faq-answer">

                        <p>
                          Not necessarily. The level of autonomy can
                          depend on the workflow. Some tasks may be
                          automated while other actions can remain
                          subject to rules, approvals, or human review.
                        </p>

                      </div>

                    )}

                  </div>


                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "ai-3"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "ai-3"
                            ? null
                            : "ai-3"
                        )
                      }
                    >

                      <span>
                        Can AI automation be customized for our business?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "ai-3" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "ai-3" && (

                      <div className="home-faq-answer">

                        <p>
                          Dropgear IO is being designed around adaptable
                          workflows so AI capabilities can be aligned
                          with different operational processes,
                          business rules, and industry requirements.
                        </p>

                      </div>

                    )}

                  </div>

                </div>

              )}


              {/* =================================================
          BUSINESS
      ================================================= */}

              {activeFaqTab === "business" && (

                <div className="home-faq-list">

                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "business-1"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "business-1"
                            ? null
                            : "business-1"
                        )
                      }
                    >

                      <span>
                        Which industries can use Dropgear IO?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "business-1" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "business-1" && (

                      <div className="home-faq-answer">

                        <p>
                          Dropgear IO can be applied to operational
                          workflows across areas such as retail and
                          ecommerce, healthcare, logistics, finance,
                          professional services, and enterprise
                          operations.
                        </p>

                      </div>

                    )}

                  </div>


                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "business-2"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "business-2"
                            ? null
                            : "business-2"
                        )
                      }
                    >

                      <span>
                        Is Dropgear IO suitable for growing businesses?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "business-2" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "business-2" && (

                      <div className="home-faq-answer">

                        <p>
                          Dropgear IO is being designed to support teams
                          at different stages of AI adoption, allowing
                          businesses to begin with focused workflows
                          and expand automation as their requirements
                          grow.
                        </p>

                      </div>

                    )}

                  </div>


                  <div className="home-faq-item">

                    <button
                      className={
                        openFaq === "business-3"
                          ? "open"
                          : ""
                      }
                      onClick={() =>
                        setOpenFaq(
                          openFaq === "business-3"
                            ? null
                            : "business-3"
                        )
                      }
                    >

                      <span>
                        How can we discuss our specific requirements?
                      </span>

                      <span className="faq-plus">
                        {openFaq === "business-3" ? "−" : "+"}
                      </span>

                    </button>

                    {openFaq === "business-3" && (

                      <div className="home-faq-answer">

                        <p>
                          You can contact the Dropgear IO team to discuss
                          your current workflows, automation goals,
                          integration requirements, and potential
                          use cases.
                        </p>

                      </div>

                    )}

                  </div>

                </div>

              )}

            </div>


            {/* =================================================
        FAQ BOTTOM CTA
    ================================================= */}

            <div className="home-faq-bottom">

              <div>

                <span className="home-faq-bottom-label">
                  STILL HAVE QUESTIONS?
                </span>

                <h3>
                  Let's talk about what you want to automate.
                </h3>

              </div>

              <a
                href="/contact"
                className="home-faq-contact-btn"
              >
                Talk to Dropgear IO
                <span>→</span>
              </a>

            </div>

          </div>

        </section>



        {/* Future home sections will be added here */}

      </main>

      <Footer />
    </>
  );
};

export default Home;